// @ts-ignore
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
import GoogleLogin from 'react-google-login';
import { FormattedMessage } from 'react-intl';
import useGoogleClientId from 'hooks/useGoogleClientId';
import FacebookLoginButton from 'components/forms/buttons/FacebookLoginButton';
import SubmitButton from 'components/forms/buttons/SubmitButton';
import classNames from 'classnames';
import useFacebookAppId from 'hooks/useFacebookAppId';
import * as baseStyles from '../../styles/baseStyles.module.scss';
import * as styles from './AltLoginsForm.module.scss';

type Props = {
  appleLoginHandler: (response: any) => void;
  className?: string;
  facebookLoginHandler: (response: any) => void;
  googleLoginHandler: (response: any) => void;
};

export default function AltLoginsForm({ appleLoginHandler, className, facebookLoginHandler, googleLoginHandler }: Props) {
  const facebookAppId = useFacebookAppId();
  const googleClientId = useGoogleClientId();

  return (
    <div className={classNames(baseStyles.section, className)}>
      <GoogleLogin
        clientId={googleClientId}
        render={renderProps => (
          <div className={styles.item}>
            <SubmitButton
              text={<FormattedMessage defaultMessage="Continue with Google" />}
              handler={renderProps.onClick}
              variant="googleLogin"
              dataTestId="loginWithGoogle"
            />
          </div>
        )}
        buttonText="Login"
        onSuccess={googleLoginHandler}
        // don't send onFailure to Bugsnag, these are expected events like popup_closed_by_user
        cookiePolicy="single_host_origin"
      />
      <FacebookLogin
        disableMobileRedirect
        appId={facebookAppId}
        autoLoad
        callback={facebookLoginHandler}
        scope="email,user_friends,user_gender,user_birthday,user_location"
        render={(renderProps: { onClick: () => void }) => (
          <div className={styles.item}>
            <FacebookLoginButton text={<FormattedMessage defaultMessage="Continue with Facebook" />} handler={renderProps.onClick} />
          </div>
        )}
      />
      <div>
        <SubmitButton
          text={<FormattedMessage defaultMessage="Continue with Apple" />}
          handler={appleLoginHandler}
          variant="appleLogin"
          dataTestId="loginWithApple"
        />
      </div>
    </div>
  );
}
